import React from 'react';
import styles from './styles.module.scss';

import H2 from '../../../../components/Basic/WrapsStyle/H/H2';
import TextGrey from '../../../../components/Basic/WrapsStyle/TextGrey';
import cn from 'classnames';

const DateButton = ({ date = '', num = '', selected, ...props }) => {
  return (
    <div className={cn(styles.date, selected && styles.selected)} {...props}>
      <H2 style={{ fontSize: '16px' }}>{date}</H2>
      <TextGrey>{`${num} заказов`}</TextGrey>
    </div>
  );
};

export default DateButton;
